import React, { createContext, useContext, useState, useEffect } from "react";

export const TimeSetExecution = createContext();

export const TimeSetExecutionProvider = (props) => {
  const [timeSet, setTimeSet] = useState(0); //Segundos transcurridos
  const [executionState, setExecutionState] = useState(false);
  const [taskToExecute, setTaskToExecute] = useState(null);

  const ExecuteProcedure = (task,ciclos) => {
    //setObjectSender(e);
    setTaskToExecute(() => task);
    setExecutionState(true);
    setTimeSet(ciclos);
  };

  useEffect(() => {
    if (executionState) {
      if (timeSet >= 1) {
        if (timeSet === 1) {
            taskToExecute();
        }
        setTimeSet(timeSet - 1);
      } else {
        setExecutionState(false);
        setTimeSet(0);
      }
    }
  }, [timeSet]);

  return (
    <TimeSetExecution.Provider
      value={{
        ExecuteProcedure,
      }}
    >
      {props.children}
    </TimeSetExecution.Provider>
  );
};

export const useTimeSetExecution = () => useContext(TimeSetExecution);
